// extracted by mini-css-extract-plugin
module.exports = {"btn":"BtnAlertes_btn__2OAZ_","isAlertesOpen":"BtnAlertes_isAlertesOpen__3K_GK","svg":"BtnAlertes_svg__LaGOj"};